import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FormCostCenter } from "../components/FormCostCenter";
import { ICostCenter } from "../../../../@types/costCenter.type";
import { IApiResponse } from "../../../../@types/api-response.type";
import { getCostCenterById } from "../../../../services/api/costCenter/costCenterService";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";
import styles from "./styles.module.scss";
import { useSyncActive } from "../../../../utils/useSyncActive";

export const UpdateCostCenter: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [costCenter, setCostCenter] = useState<ICostCenter>({} as ICostCenter);
  const { id } = useParams();
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.costCenter.id);

  const isSyncActive = useSyncActive();

  useEffect(() => {
    async function fechCostCenterById() {
      try {
        setLoading(true);

        if (!id) {
          toast.error("ID do Centro de Custo não fornecido!");
          navigate("/*");
          return;
        }

        const response = (await getCostCenterById(
          id
        )) as IApiResponse<ICostCenter>;

        if (!response.result) {
          toast.error("Centro de Custo não encontrado!");
          navigate("/*");
          return;
        }

        setCostCenter(response.result);
      } catch (error) {
        console.log(error);
        toast.error("Erro ao carregar o Centro de Custo!");
      } finally {
        setLoading(false);
      }
    }

    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }

    fechCostCenterById();
  }, [id]);

  return (
    <>
      {loading ? (
       <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
        <CircularProgress size={100} />
      </div>
      ) : (
        <div className={styles.updateCostCenter}>
          <FormCostCenter pageType="update" costCenterData={costCenter} isSyncActive={isSyncActive} />
        </div>
      )}
    </>
  );
};
